const ossLink = 'https://oss.eventnet.cn/H5/kwaiPlay/img/';
let ossImage = [
    // require('相对图片地址1'),
    ossLink + 'load.png',
    ossLink + 'bg.jpg',
    ossLink + 'bgFooter.png',
    ossLink + 'titleLive.png',
    ossLink + 'titleVideo.png',
    ossLink + 'titleArticles.png',
    ossLink + 'iconTips.gif',
    ossLink + 'iconBg.png',
    ossLink + 'bgLive.jpg',
    ossLink + 'banner.jpg',
    ossLink + 'sprite2.png',
    ossLink + 'nice.png',
    ossLink + 'nice2.png',
    ossLink + '24gf-playCircle.png',
    ossLink + 'btn1.png',
    ossLink + 'btn2.png',
    ossLink + 'btn3.png?v=2',
    ossLink + 'btn4.png',
    ossLink + '1.jpg',
    ossLink + '2.jpg'
];
export default ossImage;
